import { useContext } from 'react';
import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import PageHeading from '../../../../../Components/PageHeading';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import useCommonStyles from '../../../../../commonStyles';
import TerminateAdAfterDuration from '../TerminateAdAfterDuration';
import BackPocketAdDelaySection from './BackPocketAdDelaySection.jsx';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import SequentialAdControlDisableConfig from '../SequentialAdControlDisableConfig';
import SeqAdRequestSectionSplit from '../SeqAdRequestSectionSplit.jsx';

const AggressiveAdRequests = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Sequential Ad Control"
				headingPath={['Dashboard', 'Framerate', 'Request Structure Data', 'Sequential Ad Control']}
				showInfoButton={true}
				infoMessage={featureDescription}
			/>

			<SeqAdRequestSectionSplit keyData={'requestStructureData.seqAdRequestsSectionSplit'} />

			<Divider style={{ width: '92%', marginLeft: '3%', marginTop: '5rem' }} />

			<Grid container spacing={3} direction="row" sx={{ mt: '4rem', ml: '2rem', width: '91%' }}>
				<Grid item xs={12}>
					<Grid container sx={{ justifyContent: 'space-between' }}>
						<Grid
							item
							className={commonStyleClasses.basicOutlinedBox}
							sx={{ mb: '3rem', ml: '0' }}
							xs={12}
							md={5.8}
						>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									gap: '1rem',
									alignItems: 'flex-start',
									mb: 1.5
								}}
							>
								<Typography variant="h6" sx={{ fontWeight: 600 }}>
									Subsequent Ad Requests
								</Typography>
								<Typography variant="body2" sx={{ fontWeight: 600 }}>
									(Enable/disable subsequent ad requests.)
								</Typography>
							</Box>

							<CheckBoxInput
								containerStyles={{ width: '12rem' }}
								keyData={`${keyData}.enabled`}
								label="Enabled"
								defaultChecked={false}
								object={rawConfig}
								updateObject={updateRawConfig}
							/>
							<Divider style={{ width: '100%', margin: '2rem 0 3rem' }} />

							<BackPocketAdDelaySection keyData={`${keyData}.backPocketAdStartDelayConfig`} />
						</Grid>
						<Grid item xs={12} md={5.8}>
							<TerminateAdAfterDuration keyData="requestStructureData.terminateAdAfterDuration" />
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12}>
					<SequentialAdControlDisableConfig
						keyData={'requestStructureData.seqAdControlDisableConfig'}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default AggressiveAdRequests;
